import React from 'react'
import PropTypes from 'prop-types'
import RankUpImg from 'src/assets/img/house/nav_rank_up.png'

export const RankUpButton = ({ onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`z-50 cursor-pointer hover:scale-105 transition-transform w-full h-full flex items-center justify-center ${className}`}
    >
      <img src={RankUpImg} alt="Rank Up" className="w-full h-full object-contain" />
    </button>
  )
}

RankUpButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string
}
